import * as React from 'react'
import type { MenuT } from '../models/menus'
import { Link } from 'react-router-dom'
import styles from './Carousel.module.css'

type CarouselT = {
  items: Array<MenuT>
  isActiveMenu: (navPath: string) => boolean,
  storeId: string,
}

function Carousel ({ items, isActiveMenu, storeId }: CarouselT) {
  const navItems = React.useRef<HTMLDivElement>(null)

  return (
    <>
      <div ref={navItems} className={styles.navItems}>
        <div className={styles.items}>
          {items.map(({ id, name }: MenuT) => (
            <Link key={id} className={isActiveMenu(`/butik/${storeId}/restaurant/${id}`) ? styles.activeMenuButton : styles.menuButton} to={`/butik/${storeId}/restaurant/${id}`}>{name}</Link>
          ))}
        </div>
      </div>
    </>
  )
}

export default Carousel